import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HEADER } from '@/constants/testIds';
import { Compass, Trophy, Sparkles, GraduationCap } from 'lucide-react';
import { UserMenu } from '@/components/UserMenu';

const Header = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const navigate = useNavigate();
  const studentName = sessionStorage.getItem('studentName') || localStorage.getItem('studentName') || 'Student';

  useEffect(() => {
    if (!localStorage.getItem('learnerId')) navigate('/', { replace: true });
  }, [navigate]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <header 
      data-testid={HEADER.container}
      className="fixed top-0 w-full h-16 backdrop-blur-xl bg-[#050505]/80 border-b border-white/10 z-50 flex items-center justify-between gap-3 px-3 sm:px-6"
    >
      <div className="flex items-center gap-2 sm:gap-3 cursor-pointer flex-shrink-0" onClick={() => navigate('/dashboard')} data-testid={HEADER.title}>
        <Compass className="w-6 h-6 text-[#FFB800]" />
        <span className="font-heading text-lg font-semibold tracking-tight text-white whitespace-nowrap">
          <span className="sm:hidden">DSA With Kapil</span>
          <span className="hidden sm:inline">DSA With Kapil</span>
        </span>
      </div>

      <div className="flex items-center gap-3 sm:gap-6 min-w-0">
        <button
          data-testid="header-challenges-link"
          onClick={() => navigate('/challenges')}
          className="flex items-center gap-1.5 text-sm text-[#A1A1AA] hover:text-[#EC4899] transition-colors font-body"
        >
          <Sparkles className="w-4 h-4" />
          <span className="hidden sm:inline">Challenges</span>
        </button>
        <button
          data-testid="header-assessment-link"
          onClick={() => navigate('/assessment')}
          className="flex items-center gap-1.5 text-sm text-[#A1A1AA] hover:text-[#FFB800] transition-colors font-body"
        >
          <GraduationCap className="w-4 h-4" />
          <span className="hidden sm:inline">Final Assessment</span>
        </button>
        <button
          data-testid="header-badges-link"
          onClick={() => navigate('/badges')}
          className="flex items-center gap-1.5 text-sm text-[#A1A1AA] hover:text-[#FFB800] transition-colors font-body"
        >
          <Trophy className="w-4 h-4" />
          <span className="hidden sm:inline">Badges</span>
        </button>
        <UserMenu studentName={studentName} />
        <div 
          data-testid={HEADER.dateTime} 
          className="hidden md:flex items-center gap-4 text-sm font-code text-[#A1A1AA]"
        >
          <span>{formatDate(currentTime)}</span>
          <span className="text-[#007AFF]">{formatTime(currentTime)}</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
